import React from "react";
import { Action, Room, Schedule, taskBucket, taskCounts } from "./api";
import { TaskTable } from "./TaskTable";
export function duration(minutes: number) {
  const hours = Math.floor(minutes / 60),
    rest = minutes % 60;
  return [hours ? `${hours}hr` : "", rest || !hours ? `${rest}min` : ""]
    .filter(Boolean)
    .join(" ");
}
export function FrontDesk({
  data,
  act,
}: {
  data: Schedule;
  act: (room: Room, body: Action) => Promise<void>;
}) {
  const counts = taskCounts(data.rooms);
  const declined = data.rooms
    .flatMap((r) => r.days.flatMap((d) => d.tasks))
    .filter((t) => t.state === "declined").length;
  const sections = [
    { title: "Overdue", key: "overdue", color: "danger" },
    { title: "To Do Today", key: "todo", color: "primary" },
    { title: "Done Today", key: "done", color: "success" },
    ...(declined
      ? [{ title: "Declined", key: "declined", color: "secondary" }]
      : []),
  ];
  return (
    <div className="hk-modal-body">
      <div className="hk-summary-cards">
        {sections.slice(0, 3).map((s) => (
          <div className={`hk-summary-card bg-${s.color}`} key={s.key}>
            <strong>{counts[s.key as keyof typeof counts]}</strong>
            <span>{s.title}</span>
          </div>
        ))}
      </div>
      <p className="hk-remaining">
        {duration(
          data.totals.reduce((sum, d) => sum + d.outstandingMinutes, 0),
        )}{" "}
        of cleaning remaining
        {declined ? ` · ${declined} declined (carry to tomorrow)` : ""}
      </p>
      {sections.map((s) => {
        const rooms = data.rooms
          .map((r) => ({
            ...r,
            days: r.days
              .map((d) => ({
                ...d,
                tasks: d.tasks.filter((t) =>
                  s.key === "declined"
                    ? t.state === "declined"
                    : t.state !== "declined" && taskBucket(t) === s.key,
                ),
              }))
              .filter((d) => d.tasks.length),
          }))
          .filter((r) => r.days.length);
        const count = rooms.reduce(
          (sum, r) => sum + r.days.reduce((n, d) => n + d.tasks.length, 0),
          0,
        );
        return (
          <section
            className={`hk-status-section hk-status-${s.color}`}
            key={s.key}
          >
            <h2>
              {s.title} ({count})
            </h2>
            <TaskTable
              rooms={rooms}
              act={act}
              settingsVersion={data.settingsVersion}
              whiteBadges
              compact
              timezone={data.timezone}
            />
          </section>
        );
      })}
    </div>
  );
}
